module.exports = __webpack_public_path__ + "static/img/driver-top-2.1baae03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/driver-top-2.jpg
// module id = rK/R
// module chunks = 0